import { companiesRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';

export const useEnableCompany = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    companiesRepo.enableCompany(id),
  );
